import { createContext, useContext, useState, useEffect } from "react";

const HomeContext = createContext({});

export const HomeProvider = (props) => {
  const [isAuth, setIsAuth] = useState(localStorage.getItem("auth"));
  useEffect(() => {
    setIsAuth(localStorage.getItem("auth"));
  }, [isAuth]);
  return (
    <HomeContext.Provider
      value={{
        isAuth,
        setIsAuth,
      }}
    >
      {props.children}
    </HomeContext.Provider>
  );
};

export const useHCustomization = () => {
  const context = useContext(HomeContext);
  return context;
};
